import React, { useEffect, useState } from "react"
import { connect } from "react-redux";
import { ClienteViewProps,mapDispatchToClienteProps,mapStateToClienteProps } from "../cliente.controll";
import { Cliente } from "../cliente.model";



function ClienteList(props:ClienteViewProps){
    
    useEffect(()=>{
        props.clienteActions.read();
    },[])

    const Alterar = (row:Cliente) => {
        const handle = () => {
            props.clienteActions.set(row);
            //navigateToCadCliente();
        }

        return (
            <button onClick={handle}>Alterar</button>
        )
    }

    const Deletar = (row:Cliente) => {
        return (
            <button onClick={()=>props.clienteActions.deletar(row)}>Remover</button>
        )
    }    
    return (
        <div>
            <h2>Cliente list OWN</h2>

            <br/>
            <table>
                <thead>
                    <tr>
                        <th>Cliente</th>
                        <th>Adicionado</th>
                        <th>Alterado</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                {props.clienteState.rows.map((row,idx)=>(
                    <tr key={idx}>
                        <td>{row.nome}</td>
                        <td>{row.created_at}</td>
                        <td>{row.modified_at}</td>
                        <td style={{display:"flex",flexDirection:"row", padding:1}}>
                            <Alterar {...row} />
                            <Deletar {...row} />
                        </td>                        
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    )
}

export default connect(mapStateToClienteProps,mapDispatchToClienteProps)(ClienteList);